import { useCallback, useEffect, useState } from 'react';
import { inventarioApi, isOfflineError, cache } from '../services/inventarioApi';
import { formatearFechaLocal, normalizarFechaISO } from '../../../utils/horaLocal';

const ENTIDAD = 'gastos';

export function useGastosInventario(enabled = true) {
  const [gastos, setGastos] = useState([]);

  const fetchGastos = useCallback(async () => {
    try {
      const data = await inventarioApi.getAll(ENTIDAD);
      setGastos(data);
      cache.set(ENTIDAD, data);
    } catch (e) {
      if (isOfflineError(e)) setGastos(cache.get(ENTIDAD) || []);
    }
  }, []);

  useEffect(() => { if (enabled) fetchGastos(); }, [fetchGastos, enabled]);

  const obtenerGastosPorFecha = (fecha) => {
    if (!gastos) return [];
    const formatoFecha = formatearFechaLocal(normalizarFechaISO(fecha));
    return gastos.filter(g => {
      const fechaGasto = formatearFechaLocal(normalizarFechaISO(g.fecha));
      return fechaGasto === formatoFecha && g.estado !== 'ANULADO';
    });
  };

  return {
    gastos,
    setGastos,
    obtenerGastosPorFecha,
    refetch: fetchGastos,
  };
}
